import { atom } from "recoil";

const CategoryFilterAtom = atom({
    default: 'all',
    key: 'categoryFilterAtom'
})

export default CategoryFilterAtom;